interface LessonLimitDisplayProps {
  remaining: number;
}

export function LessonLimitDisplay({ remaining }: LessonLimitDisplayProps) {
  return (
    <span
      style={{
        fontSize: 12,
        color: 'var(--color-text-muted)',
        fontFamily: 'var(--font-sans)',
      }}
    >
      {remaining} lesson{remaining !== 1 ? 's' : ''} remaining this month
    </span>
  );
}
